import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";
import { UserType } from "../../../context/AuthContext";

export function getConversations(headers: {
  ActorId: string | number | undefined;
  ActorType: string | UserType | undefined;
}): Promise<ApiResponse> {
  return Axios.get(`v1/conversations`, {
    headers,
    params: {
      order_by: "last_message_sent_at",
    },
  });
}

export function getConversationClientToken(headers: {
  ActorId: string | number | undefined;
  ActorType: string | UserType | undefined;
}): Promise<ApiResponse> {
  return Axios.get(`v1/conversations/token`, { headers });
}
export function addConversation(
  headers: {
    ActorId: string | number | undefined;
    ActorType: string | UserType | undefined;
  },
  body: {
    participant_id: string | number | null;
    participant_type: string | UserType | undefined;
  }
): Promise<ApiResponse> {
  return Axios.post(`v1/conversations`, body, { headers });
}
export function getContacts(headers: {
  ActorId: string | number | undefined;
  ActorType: string | UserType | undefined;
}): Promise<ApiResponse> {
  return Axios.get(`v1/contacts`, { headers });
}

export function getParticipantData(params: object): Promise<ApiResponse> {
  return Axios.get(`v1/conversations/show_participant`, { params });
}
export function getLastMessage(params: object): Promise<ApiResponse> {
  return Axios.get(`v1/conversations/last_message_sent_at`, { params });
}
